import React from "react";
export const DataTableIcon = (props) => {
    return React.createElement("img", { src: props.icon, style: { height: '24px', margin: '-2px', position: 'absolute' } });
};
